import Config, {defaultGameStats} from './config'
import {isLaunchDev} from './utils'
import {isDebug} from '../launch/utils'

export const resetGameStore = () => {
    return new Promise((resolve, reject) => {
        // Assign id to game to be compared in game over check
        const time = new Date().getTime()
        defaultGameStats.gameId = time

        Config.artifacts = {}
        Config.entities = {}
        Config.gameStats = Object.assign({}, defaultGameStats)
        Config.ships = {}
        return resolve()
    })
}

export const getStoredState = () => {
    let storedState = window.localStorage.getItem(Config.namespace)
    storedState = storedState ? JSON.parse(storedState) : null

    // Resetting the game
    if (Config.isResetting) {
        Config.isResetting = false

        resetGameStore()

        return {
            careerStats: storedState
                ? storedState.careerStats
                : Config.careerStats,
            gameStats: Object.assign({}, defaultGameStats),
            isResetting: true,
        }
    }

    return storedState
}

export const saveGame = (trigger) => {
    return new Promise((resolve, reject) => {
        if (isLaunchDev || Config.isDemo) {
            return
        }

        const config = Config
        const artifacts = {}
        const entities = {}
        const ships = {}

        // Select which artifact props we want to store
        Object.keys(config.artifacts).forEach((key) => {
            const artifact = Object.assign({}, config.artifacts[key])

            artifacts[key] = {
                isDiscovered: artifact.isDiscovered,
                isInOrbit: artifact.isInOrbit,
                isBeingTowed: artifact.isBeingTowed,
                orbitingEntityId: artifact.orbitingEntity?.id,
                towShipId: artifact.towShipId,
                x: artifact.x,
                y: artifact.y,
            }
        })

        // Select which entity props we want to store
        Object.keys(config.entities).forEach((key) => {
            const entity = Object.assign({}, config.entities[key])

            entities[key] = {
                climate: entity.climate,
                colonized: entity.colonized,
                diameter: entity.diameter,
                discovered: entity.discovered,
                isHomePlanet: entity.isHomePlanet,
                isMiningResources: entity.isMiningResources,
                faction: entity.faction,
                featureColor: entity.featureColor,
                featureId: entity.featureId,
                fillColor: entity.fillColor,
                name: entity.name,
                orbitingShips: entity.orbitingShips,
                type: entity.type,
                x: entity.x,
                y: entity.y,
            }
        })

        // Select which ship props we want to store
        Object.keys(config.ships).forEach((key) => {
            const ship = Object.assign({}, config.ships[key])

            ships[key] = {
                angle: ship.angle,
                faction: ship.faction,
                health: ship.health,
                id: ship.id,
                name: ship.name,
                orbitingEntityId: ship.orbitingEntity
                    ? ship.orbitingEntity.id
                    : null,
                rank: ship.rank,
                type: ship.type,
                x: ship.x,
                y: ship.y,
            }
        })

        const state = {
            artifacts,
            careerStats: config.careerStats,
            config: {
                boardSize: config.boardSize,
                difficulty: config.difficulty,
                isMuted: config.isMuted,
            },
            entities,
            gameStats: config.gameStats,
            ships,
        }

        isDebug && console.log('Saving...', trigger)

        window.localStorage.setItem(config.namespace, JSON.stringify(state))

        return resolve()
    })
}

export const addGameStatsToCareer = () => {
    return new Promise((resolve, reject) => {
        const {gameStats} = Config

        if (gameStats.victory) {
            Config.careerStats.victories += 1
        } else {
            Config.careerStats.losses += 1
        }

        Config.careerStats.artifactsCollected += gameStats.artifactsCollected
        Config.careerStats.planetsColonized += gameStats.planetsColonized
        Config.careerStats.planetsConquered += gameStats.planetsConquered
        Config.careerStats.planetsLost += gameStats.planetsLost
        Config.careerStats.score += gameStats.score
        Config.careerStats.shipsBuilt += gameStats.shipsBuilt
        Config.careerStats.shipsDestroyed += gameStats.shipsDestroyed
        Config.careerStats.shipsLost += gameStats.shipsLost

        isDebug &&
            console.log('addGameStatsToCareer', gameStats, Config.careerStats)

        return resolve()
    })
}
